import React, { useState } from 'react';
import { FormControlLabel } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioGroup from '@material-ui/core/RadioGroup';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export default function VerifyHouse(props) {
    const handleNonComment = (e) => {
        props.values.non_owner_comments = e.target.value
        if (props.values.is_owner === 'yes') {
            props.values.non_owner_comments = ''
        }
    }
    const handleNonResidentComment = (e) => {
        props.values.non_resident_comments = e.target.value
        if (props.values.is_primary_residence === 'yes') {
            props.values.non_resident_comments = ''
        }
    }
    const resetInputField = () => {
        props.values.non_owner_comments = ''
        props.values.non_resident_comments = ''
    };

    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    return (
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0">
                    Do you currently own this house?
                </h4>
                <span className="montserrat-medium ">{props.values.property_address.street_address}</span>
                <div className="pt-2 form-content-field">
                    <div className="py-2">
                        <RadioGroup
                            name="is_owner"
                            value={props.values.is_owner}
                            onClick={resetInputField}
                            onChange={props.handleChange}
                            style={{ width: 'fit-content' }}
                        >
                            <div>
                                <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                            </div>
                        </RadioGroup>
                    </div>
                </div>
                {props.values.is_owner === 'no' ?
                    <>
                        <div className="">
                            <h6>Please clarify.</h6>
                        </div>
                        <div className="py-2 row">
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <TextField
                                    type="text"
                                    id="non_owner_comments"
                                    variant="outlined"
                                    name="non_owner_comments"
                                    onChange={handleNonComment, props.handleChange}
                                    value={props.values.non_owner_comments.trimStart()}
                                    placeholder=""
                                    inputprops={{maxLength : 249}}
                                    multiline
                                    className="w-100"
                                />
                            </div>
                        </div>
                    </>
                    : 
                    props.values.is_owner === 'yes' ? 
                    <>
                    <h6>
                    Is this house your primary residence?
                    </h6>
                    <div className="pt-2 form-content-field">
                        <div className="py-2">
                            <RadioGroup
                                name="is_primary_residence"
                                value={props.values.is_primary_residence}
                                onClick={resetInputField}
                                onChange={props.handleChange}
                                style={{ width: 'fit-content' }}
                            >
                                <div>
                                    <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                    <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                </div>
                            </RadioGroup>
                        </div>
                    </div>
                    </>:""}
                    {props.values.is_primary_residence === 'no' && props.values.is_owner === 'yes' ?
                    <>
                        <div className="">
                            <h6>Comments.</h6>
                        </div>
                        <div className="py-2 row">
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <TextField
                                    type="text"
                                    id="non_resident_comments"
                                    variant="outlined"
                                    name="non_resident_comments"
                                    onChange={handleNonResidentComment, props.handleChange}
                                    value={props.values.non_resident_comments.trimStart()}
                                    placeholder=""
                                    inputprops={{maxLength : 249}}
                                    multiline
                                    className="w-100"
                                />
                            </div>
                        </div>
                    </>:""}
                {props.validateDisplay === true ?
                    props.errors.non_owner_comments !== '' ?
                        <div className="error-msg">{props.errors.non_owner_comments}</div> : ''
                    : ''}
            </div>
        </div>
    )
}
